// extracted by mini-css-extract-plugin
export var content = "_47-3";
export var list = "_47-4";
export var settingsContent = "_47-7";
export var settingsPanel = "_47-8";
export var state = "_47-6";
export var triggerBadge = "_47-2";
export var triggerButton = "_47-1";
export var triggerShell = "_47-0";
export var unreadDot = "_47-5";